export default "__VITE_ASSET__oKATVI6x__"